<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("message.mlChannelDetails") }}</div>
            <div class="subtitle">{{ $t("message.manageMlChannel") }}</div>
        </div>

        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("message.channelName") }}</label>
                    <a-input
                        :placeholder="$t('message.channelName')"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>
            </div>
        </a-form>
        <!--        <ChannelForwardSetting :channel="clone" />-->
        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import { mapActions, mapState } from "vuex";
import ChannelForwardSetting from "../../../IntegrationChannelsItem/ChannelForwardSetting.vue";

const log = log2("UpdateDetail.vue");
export default Vue.extend({
    name: "UpdateDetail",
    components: {
        ChannelForwardSetting,
    },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
            showStories: !!this.value.forward.story,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
        }),
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("message.channelUpdatedSucs"));
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("message.failedUpdateChannel"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {
        this.listStories();
    },
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
